import { render, staticRenderFns } from "./AboutProductSection.htm?vue&type=template&id=35a916cc&scoped=true&external"
import script from "./AboutProductSection.js?vue&type=script&lang=js&external"
export * from "./AboutProductSection.js?vue&type=script&lang=js&external"
import style0 from "./AboutProductSection.scss?vue&type=style&index=0&id=35a916cc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a916cc",
  null
  
)

export default component.exports